import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { WaitlistFormFields } from "./waitlist/WaitlistFormFields";
import { WaitlistConsent } from "./waitlist/WaitlistConsent";
import { useWaitlistForm } from "@/hooks/use-waitlist-form";

interface WaitlistFormProps {
  isPro: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const WaitlistForm = ({ isPro, onOpenChange, open }: WaitlistFormProps) => {
  const { formData, setFormData, isLoading, handleSubmit } = useWaitlistForm(isPro, () => onOpenChange(false));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogTitle>
          {isPro ? "Inscription à la liste d'attente Pro" : "Inscription à la liste d'attente"}
        </DialogTitle>
        <DialogDescription>
          {isPro 
            ? "6 mois gratuits pour dire adieu aux réservations galère."
            : "Inscrivez-vous pour avoir un accès early à la carte des pépites."
          }
        </DialogDescription>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <WaitlistFormFields
            formData={formData}
            setFormData={setFormData}
            isPro={isPro}
          />
          
          <WaitlistConsent
            formData={formData}
            setFormData={setFormData}
            isPro={isPro}
          />

          <Button
            type="submit"
            className="w-full"
            disabled={isLoading}
          >
            {isLoading ? "Envoi en cours..." : "S'inscrire"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};